import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { emptySearchSchool, searchSchool } from "../../../redux/actions/common";
import { createAccount } from "../../../redux/actions/auth";
import { isValidString } from "../../../helper";

const Registration = ({ onComplete, toggleForm }) => {

   const dispatch = useDispatch();
   const selectRef = useRef();

   const initialData = {
      personName: "",
      schoolId: "",
      accountRole: "",
      mobile: ""
   }

   const mobile = useSelector(state => state.auth.mobile);

   const [formData, setFormData] = useState(initialData);
   const [schoolList, setSchoolList] = useState([]);
   const [school, setSchool] = useState({ label: "", value: "" });
   const [inputValue, setInputValue] = useState();
   const [error, setError] = useState({});

   useEffect(() => {
      if (mobile) {
         setFormData({ ...formData, mobile });
      }
      return () => dispatch(emptySearchSchool())
   }, [mobile])

   const handleOnChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

   const onInputChange = value => {
      setError({ ...error, schoolId: "" });
      setInputValue(value);
      setSchoolList([])
      if (value.length > 2) {
         dispatch(searchSchool(value, (data) => {
            const list = data?.map(item => ({ label: item?.displayName, value: item.id }))
            setSchoolList(list);
         }));

      }
   }

   const handleSubmit = e => {
      e.preventDefault();
      const { personName, accountRole, mobile } = formData;
      if (!isValidString(personName)) {
         setError(prevState => ({ ...prevState, personName: "Name is required!" }))
      }
      if (!isValidString(accountRole)) {
         setError(prevState => ({ ...prevState, accountRole: "Role is required!" }))
      }
      if (!mobile) {
         setError(prevState => ({ ...prevState, mobile: "Mobile is required!" }))
      }
      if (!school?.value) {
         setError(prevState => ({ ...prevState, schoolId: "School is required!" }))
      }
      if (personName && school?.value && accountRole && mobile) {
         const regex = /^([+]\d{2})?\d{10}$/;
         if (regex.test(mobile)) {
            const data = {
               personName,
               accountRole,
               mobile
            }
            if (school?.__isNew__)
               data["schoolName"] = school?.value
            else
               data["schoolId"] = school?.value

            dispatch(createAccount(data, onComplete));
         } else {
            setError(prevState => ({ ...prevState, mobile: "Number format incorrect!" }))
         }
      }
   }

   const handleFocus = e => setError({ ...error, [e.target.name]: "" })

   const handleSelectFocus = e => {
      setTimeout(() => {
         if (school?.value && selectRef.current?.inputRef) {
            selectRef.current.inputRef.value = school.value
            document.getElementById("schoolSearchInput").focus();
         }
      }, 100)
      setError({ ...error, [e.target.name]: "" })
   }

   const handleBlur = (e) => {
      const { value } = e.target;
      if (value) {
         const option = { label: value, value: value, __isNew__: true }
         setSchoolList([option]);
         setInputValue(value);
         setSchool(option);
      }
   }

   return (
      <div className="create-acc-form form-sec">
         <p className="form-heading">Create account</p>
         <form className="main-form">
            <div className={`form-feild`}>
               <label htmlFor="name" className="form-label">Name<span className="form-error">*</span></label>
               <input type="text" name="personName" value={formData?.personName} onFocus={handleFocus} onChange={handleOnChange} className="form-control mb-0" />
               <span className="form-error" >{error?.personName}</span>
            </div>
            <div className={`form-feild mt-2`}>
               <label htmlFor="schoolname" className="form-label">School name<span className="form-error">*</span></label>
               <CreatableSelect
                  ref={selectRef}
                  name="schoolId"
                  inputId="schoolSearchInput"
                  onBlur={handleBlur}
                  components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                  noOptionsMessage={() => null}
                  inputValue={inputValue}
                  onInputChange={onInputChange}
                  value={school}
                  isSearchable={true}
                  onChange={setSchool}
                  options={schoolList}
                  onFocus={handleSelectFocus}
                  isClearable={true}
                  contentEditable={true}
                  placeholder=""
               />
               <span className="form-error" >{error?.schoolId}</span>
            </div>
            <div className={`form-feild mt-2`}>
               <label htmlFor="role" className="form-label">Your role<span className="form-error">*</span></label>
               <select className="form-select" name="accountRole" value={formData?.accountRole} onFocus={handleFocus} onChange={handleOnChange}>
                  <option defaultValue disabled value="">Select</option>
                  <option value="MANAGEMENT">Management</option>
                  <option value="TEACHER">Teacher</option>
                  <option value="ADMIN">Admin Staff</option>
               </select>
               <span className="form-error" >{error?.accountRole}</span>
            </div>
            <div className={`form-feild mt-2`}>
               <label htmlFor="mobile" className="form-label">Mobile number (10 digits)<span className="form-error">*</span></label>
               <input type="text" className="form-control mb-0" name="mobile" value={formData?.mobile} onFocus={handleFocus} onChange={handleOnChange} />
               <span className="form-error" >{error?.mobile}</span>
            </div>
            <button className="btn purple-button" onClick={handleSubmit}>Submit</button>
            <p className="create-account mt-4">Existing User? <a className="nav-link" onClick={() => toggleForm(false)}>Login</a></p>
         </form>
      </div>
   );
};

export default Registration;
